module.exports = __webpack_public_path__ + "img/floor_f20_02.5f7f0a0d.png";